export default __webpack_public_path__ + "static/media/chevrolet.d765d70d.svg";